// One codebase, two public surfaces. VITE_SURFACE (baked in at build time by vite.config.ts) selects
// which brand + home route we ship. Default is aircargo.
export type Surface = 'aircargo' | 'airrates'

export const SURFACE: Surface =
  import.meta.env.VITE_SURFACE === 'airrates' ? 'airrates' : 'aircargo'

interface SurfaceConfig {
  key: Surface
  domain: string
  sibling: { label: string; href: string } // the other air surface
  wordA: string // wordmark first half (ink)
  wordB: string // wordmark second half (cobalt signal)
  eyebrow: string
  title: string // <title>
  metaDesc: string
}

const CONFIG: Record<Surface, SurfaceConfig> = {
  aircargo: {
    key: 'aircargo',
    domain: 'aircargomcp.com',
    sibling: { label: 'Air rates', href: 'https://airratesmcp.com' },
    wordA: 'Air',
    wordB: 'Cargo',
    eyebrow: 'Live AWB track & trace',
    title: 'AirCargoMCP — Track any air waybill (AWB), free',
    metaDesc:
      'Track any air waybill by its 11-digit AWB number, with live IATA Cargo-IMP milestones from origin to destination, flights and pieces, across the world’s cargo airlines.',
  },
  airrates: {
    key: 'airrates',
    domain: 'airratesmcp.com',
    sibling: { label: 'AWB tracking', href: 'https://aircargomcp.com' },
    wordA: 'Air',
    wordB: 'Rates',
    eyebrow: 'Air-freight rate terminal',
    title: 'AirRatesMCP — Air-freight rate quotes, per-kg all-in',
    metaDesc:
      'Price any air-freight lane in seconds: chargeable weight, the weight-band break, fuel and security surcharges, and an all-in per-kg figure. HKG → FRA and more.',
  },
}

export const surface = CONFIG[SURFACE]
